var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C0BEBE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.563 0H3.437C1.543 0 0 1.543 0 3.438v15.125C0 20.457 1.543 22 3.437 22h26.126C31.457 22 33 20.457 33 18.563V3.438C33 1.543 31.457 0 29.563 0zm1.375 18.022c0 1.056-.884 1.916-1.97 1.916H4.032c-1.085 0-1.968-.86-1.968-1.916V3.978c0-1.056.883-1.916 1.968-1.916H28.97c1.085 0 1.968.86 1.968 1.916v14.044z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.312 4H.688C.308 4 0 4.336 0 4.75v4.5c0 .414.308.75.688.75h31.624c.38 0 .688-.336.688-.75v-4.5c0-.414-.308-.75-.688-.75zm-1.374 4.5H2.063v-3h28.875v3zM13.286 14H4.714c-.394 0-.714.224-.714.5s.32.5.714.5h8.572c.394 0 .714-.224.714-.5s-.32-.5-.714-.5zM13.286 17H4.714c-.394 0-.714.224-.714.5s.32.5.714.5h8.572c.394 0 .714-.224.714-.5s-.32-.5-.714-.5zM26.75 12h-1.5C24.01 12 23 13.01 23 14.25v1.5c0 1.24 1.01 2.25 2.25 2.25h1.5c1.24 0 2.25-1.01 2.25-2.25v-1.5c0-1.24-1.01-2.25-2.25-2.25zm.75 3.75c0 .414-.336.75-.75.75h-1.5c-.414 0-.75-.336-.75-.75v-1.5c0-.414.336-.75.75-.75h1.5c.414 0 .75.336.75.75v1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/default-card.82f94b404d5c013b23e829db125d0cf6.svg";
export { ForwardRef as ReactComponent };